import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { LayoutComponent } from '../../../app/layout/layout.component';
import { EditorComponent } from '../../../app/pages/tasks/editor/editor.component';
import { takeUntil } from 'rxjs/operators';
import { TaskPanelService } from '../../../app/services/tasks/task-panel.service';
import { ViewerComponent } from '../../../app/pages/map/viewer/viewer.component';

@Component({
  template: ''
})
export class TaskPanelLauncherComponent implements OnInit, AfterViewInit, OnDestroy {

  private taskId: number = null;
  private tileId: number = null;

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private activatedRoute: ActivatedRoute,
              private taskPanelService: TaskPanelService,
              private router: Router,
              private layoutComponent: LayoutComponent,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params: Params): void => {
      if (params['task_id']) {
        this.taskId = params['task_id'];
        this.taskPanelService.open(this.taskId ?? null);
      } else {
        this.tileId = params['tile_id'];
        this.taskPanelService.open(this.tileId ?? null);
      }
    });

    this.taskPanelService.open$.pipe(takeUntil(this.destroy$)).subscribe((event: boolean): void => {
      if (!event) {
        this.router.navigate(
          (this.taskPanelService.editorType === 'update' ? ['../../'] : ['../']),
          {relativeTo: this.activatedRoute}).then((): void => {
          }
        );
      }
    });
  }

  ngAfterViewInit(): void {
    const interval: NodeJS.Timeout = setInterval((): void => {
      if (this.taskId || !this.taskId && !this.tileId) {
        if (typeof this.layoutComponent.taskPanelPlaceholder !== 'undefined') {
          const componentRef = this.layoutComponent.taskPanelPlaceholder.createComponent(EditorComponent);
          clearInterval(interval);
        }
      } else {
        if (typeof this.layoutComponent.tilePanelPlaceholder !== 'undefined') {
          const componentRef = this.layoutComponent.tilePanelPlaceholder.createComponent(ViewerComponent);
          componentRef.instance.tileId = this.tileId;
          clearInterval(interval);
        }
      }
    }, 100);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    console.log('clearing panels');
    this.layoutComponent.taskPanelPlaceholder.clear();
    this.layoutComponent.tilePanelPlaceholder.clear();
  }
}
